import { render } from "./coach-earning.vue?vue&type=template&id=036be729"
import script from "./coach-earning.vue?vue&type=script&lang=js"
export * from "./coach-earning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__